// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/aeroplane-upset.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/aeroplane-upset/aeroplane-upset.js';

mount([g0]);
